import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const SectionHeader = ({ overline, title, subtitle, dark = false, center = false }) => (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
        <Reveal>
            <p
                className={`text-xs font-bold uppercase tracking-[0.22em] ${
                    dark ? "text-sky-400" : "text-[#1A6AFF]"
                }`}
            >
                {overline}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`mt-4 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${
                    dark ? "text-white" : "text-slate-900"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {subtitle && (
            <Reveal delay={0.16}>
                <p
                    className={`mt-4 text-base leading-relaxed md:text-lg ${
                        dark ? "text-slate-300" : "text-slate-600"
                    }`}
                >
                    {subtitle}
                </p>
            </Reveal>
        )}
    </div>
);
